import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoadingProvider } from '../../providers/loading/loading';
import { Http, Headers, RequestOptions } from '@angular/http';
import { BrokersPage } from '../brokers/brokers';
import firebase from 'firebase/app';
import {EnvDataService} from '../../app/services/env-data-service';
@Component({
  selector: 'page-create-broker',
  templateUrl: 'create-broker.html',
  providers:[EnvDataService]
})
export class CreateBrokerPage {
    addBrokerForm: FormGroup;
    public form_name: any;
    public uid: any;
    public firstname: any;
    public lastname: any;
    public email: any;
    public mobile_phone: any;
    public mercurySeurityToken: any;
    public mercuryAgentCode: any;
    public activeCampaignKey: any;
    public getRole: any;
    public header_title: any;
    public edit_contact_uid : any;

    public validation_messages = {
      'firstname': [
          { type: 'required', message: 'Firstname is required.' }
      ],
      'lastname': [
        { type: 'required', message: 'Lastname is required.' }
      ],
      'email': [
        { type: 'required', message: 'Email is required.' }
      ],
      'mobile_phone': [
        { type: 'required', message: 'Mobile Number is required.' },
        { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
        { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
      ],
      'password': [
        { type: 'required', message: 'Password is required.' },
        { type: 'minlength', message: 'Password must be at least 6 characters long.' },
        { type: 'maxlength', message: 'Password cannot be more than 20 characters long.' },
      ],
      'mercurySeurityToken': [
        { type: 'required', message: 'Mercury Seurity Token is required.' }
      ],
      'mercuryAgentCode': [
        { type: 'required', message: 'Mercury Agent Code is required.' }
      ]
    }
    
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public formBuilder: FormBuilder, 
    public afs: AngularFirestore, 
    public modalCtrl: ModalController, 
    public afAuth:AngularFireAuth, 
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public http: Http,
    private EnvDataService:EnvDataService
  ) {
    this.form_name = "eLINK Finance";
    this.header_title = "Add New Broker";
    this.addBrokerForm = formBuilder.group({
      firstname: ['', Validators.compose([Validators.required])],
      lastname: ['', Validators.compose([Validators.required])],
      mobile_phone: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(10)])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(20)])],
      mercurySeurityToken: ['', Validators.compose([Validators.required])],
      mercuryAgentCode: ['', Validators.compose([Validators.required])]
    }); 

    this.edit_contact_uid = this.navParams.get("edit_contact_uid");
    let thiss = this;
    if(this.edit_contact_uid == null || this.edit_contact_uid == undefined || this.edit_contact_uid == ""){}else{
      this.header_title = "Update Broker";
      let gpassword = this.addBrokerForm.get('password');
      gpassword.setValidators(null);
      gpassword.updateValueAndValidity();
      window.localStorage.setItem("contact_uid", this.edit_contact_uid);
      let docRef1 = firebase.firestore().collection("users").doc(this.edit_contact_uid);
      docRef1.get().then(function(doc) {
        if (doc.exists) {
          thiss.firstname = doc.data().firstname;
          thiss.lastname = doc.data().lastname;
          thiss.email = doc.data().email;
          thiss.mobile_phone = doc.data().mobile_phone;
        }
      }).catch(function(error) {
        console.log("Error getting document:", error);
      });
      let docRef2 = firebase.firestore().collection("brokerCredentials").doc(this.edit_contact_uid);
      docRef2.get().then(function(doc) {
        if (doc.exists) {
          thiss.mercurySeurityToken = doc.data().mercurySeurityToken;
          thiss.mercuryAgentCode = doc.data().mercuryAgentCode;
        }
      }).catch(function(error) {
        console.log("Error getting document:", error);
      });
    }
    console.log(thiss.email);
  }

  isFieldValid(field: string) {
    return !this.addBrokerForm.get(field).valid && this.addBrokerForm.get(field).touched;
  }
  
  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  add_broker(){
    if(!this.addBrokerForm.valid){
      this.addBrokerForm.get('lastname').markAsDirty();
      this.addBrokerForm.get('lastname').markAsTouched();

      this.addBrokerForm.get('firstname').markAsDirty();
      this.addBrokerForm.get('firstname').markAsTouched();

      this.addBrokerForm.get('mobile_phone').markAsDirty();
      this.addBrokerForm.get('mobile_phone').markAsTouched();

      this.addBrokerForm.get('email').markAsDirty();
      this.addBrokerForm.get('email').markAsTouched();

      this.addBrokerForm.get('password').markAsDirty();
      this.addBrokerForm.get('password').markAsTouched();

      this.addBrokerForm.get('mercurySeurityToken').markAsDirty();
      this.addBrokerForm.get('mercurySeurityToken').markAsTouched();

      this.addBrokerForm.get('mercuryAgentCode').markAsDirty();
      this.addBrokerForm.get('mercuryAgentCode').markAsTouched();
    }else{
      this.loadingProvider.startLoading();
      let uid = window.localStorage.getItem("uid");
      if(uid != null){
        let firstname = this.addBrokerForm.value.firstname;
        let lastname = this.addBrokerForm.value.lastname;      
        let email = this.addBrokerForm.value.email;
        let mobile_phone = this.addBrokerForm.value.mobile_phone; 
        let password = this.addBrokerForm.value.password; 
        let mercurySeurityToken = this.addBrokerForm.value.mercurySeurityToken; 
        let mercuryAgentCode = this.addBrokerForm.value.mercuryAgentCode; 

        var headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/json' );
        const requestOptions = new RequestOptions({ headers: headers });

        let postData = {
          "uid": uid,
          "displayName": firstname,
          "email": email,
          "phoneNumber": "+6"+mobile_phone,
          "password": password,
          "firstname": firstname,
          "lastname": lastname,
          "mobile_phone": mobile_phone,
          "mercurySeurityToken": mercurySeurityToken,
          "mercuryAgentCode": mercuryAgentCode,
          "created_date" : new Date().getTime()
        }
        if(this.edit_contact_uid == null || this.edit_contact_uid == undefined || this.edit_contact_uid == ""){}else{
          postData['edit_contact_uid'] = this.edit_contact_uid;
        }
        console.log(postData);
        var url = this.EnvDataService.EnvData.sendbox_api+"/createBroker";
        this.http.post(url, postData, requestOptions)
        .subscribe(data => {
          console.log(data['_body']);
          if(data['_body'] == 'The email address is already in use by another account.'){
            this.loadingProvider.stopLoading();  
            this.presentToast(data['_body']);          
          }else if(data['_body'] == 'The user with the provided phone number already exists.'){
            this.loadingProvider.stopLoading();
            this.presentToast(data['_body']);
          }else if(data['_body'] == 'TOO_LONG'){
            this.loadingProvider.stopLoading();
            this.presentToast('Invalid Phone Number.');
          }else if(data['_body'] == 'TOO_SHORT'){
            this.loadingProvider.stopLoading();
            this.presentToast('Invalid Phone Number.');
          }else if(data['_body'] == 'Invalid format.'){
            this.loadingProvider.stopLoading();
            this.presentToast('Invalid Phone Number.');
          }else if(data['_body'] == 'The phone number must be a non-empty E.164 standard compliant identifier string.'){
            this.loadingProvider.stopLoading();
            this.presentToast('Invalid Phone Number.');
          }else{
            this.loadingProvider.stopLoading();
            this.navCtrl.push(BrokersPage);
          }
        }, error => {
          this.loadingProvider.stopLoading();
          this.presentToast(error.message);
        });
      }
    }
  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  ionViewDidLoad() {
  }

  phoneInput(event) {
    //48 - 57
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/create-broker/create-broker.ts